import { Check } from "lucide-react";
import { DETAILED_SERVICES } from "@/data/content";

export const DetailedServices = () => {
  return (
    <section data-testid="detailed-services-section" className="py-24 sm:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-2xl mb-20">
          <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#e02329] mb-3">Our Services</p>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-[#1c4f9c]">
            Detailed cleaning programs for every need
          </h2>
        </div>

        <div className="space-y-24">
          {DETAILED_SERVICES.map((svc, idx) => {
            const reverse = idx % 2 === 1;
            return (
              <div
                key={svc.id}
                id={svc.id}
                data-testid={`detailed-service-${svc.id}`}
                className="grid lg:grid-cols-2 gap-12 items-center"
              >
                <div className={reverse ? "lg:order-2" : ""}>
                  <img src={svc.image} alt={svc.title} loading="lazy" decoding="async" className="w-full h-[420px] object-cover rounded-sm shadow-lg" />
                </div>
                <div className={reverse ? "lg:order-1" : ""}>
                  <span className="text-5xl font-extrabold font-display text-slate-100">0{idx + 1}</span>
                  <h3 className="text-2xl sm:text-3xl font-bold text-[#1c4f9c] -mt-4">{svc.title}</h3>
                  <p className="mt-4 text-base text-slate-600 leading-relaxed">{svc.intro}</p>
                  <ul className="mt-6 grid sm:grid-cols-2 gap-3">
                    {svc.tasks.map((t) => (
                      <li key={t} className="flex items-center gap-3">
                        <span className="w-5 h-5 flex items-center justify-center bg-[#e02329] rounded-full shrink-0">
                          <Check size={12} className="text-white" strokeWidth={3} />
                        </span>
                        <span className="text-sm font-medium text-slate-700">{t}</span>
                      </li>
                    ))}
                  </ul>
                  <a
                    href="#contact"
                    data-testid={`detailed-cta-${svc.id}`}
                    className="inline-flex mt-8 items-center gap-2 text-sm font-bold text-[#1c4f9c] border-b-2 border-[#e02329] pb-1 hover:text-[#e02329] transition-colors duration-200"
                  >
                    Get a Free Estimate
                  </a>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
